import React from 'react';

const Idaho = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Idaho Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Two-page form required within 10 days of offer..</li>
        <li>
          Property Condition Disclosure Act: Mandates disclosure of known
          material defects.
        </li>
        <li>Water Rights: Disclosure required if applicable.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Idaho-Sellers-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure{' '}
          </span>{' '}
          – Sellers are required to complete this disclosure within 10 days of
          accepting an offer.
        </li>
      </ol>
    </div>
  );
};

export default Idaho;
